import clarity from '@microsoft/clarity';

let clarityInitialized = false;

export function initClarity() {
    const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

    if (!projectId) {
        if (process.env.REACT_APP_ENVIRONMENT === 'local') {
            console.warn(
                '[Clarity] REACT_APP_CLARITY_PROJECT_ID is not set - tracking disabled.'
            );
        }
        return;
    }

    if (clarityInitialized || window.__clarity_initialized) {
        return;
    }

    try {
        clarity.init(projectId);

        window.__clarity_initialized = true;
        clarityInitialized = true;
    } catch (err) {
        if (process.env.REACT_APP_ENVIRONMENT === 'local') {
            console.error('[Clarity] Initialization failed', err);
        }
    }
}